import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axios';

// Fetch Employee Profile
export const fetchEmployeeProfile = createAsyncThunk(
  'employeeProfile/fetch',
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/employee/${employeeId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const employeeProfileSlice = createSlice({
  name: 'employeeProfile',
  initialState: {
    profile: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearProfile: (state) => {
      state.profile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Employee Profile
      .addCase(fetchEmployeeProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data;
      })
      .addCase(fetchEmployeeProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch employee profile';
      });
  },
});

export const { clearError, clearProfile } = employeeProfileSlice.actions;
export default employeeProfileSlice.reducer;
